import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { getStrapiImageUrl } from 'lib/strapi/getStrapiImageUrl';
import { Breadcrumbs } from 'components/Breadcrumbs';
import { StrapiCategory } from 'types/strapiService/types';

import styles from './Info.module.scss';

const components = {};

interface Props {
  title: string;
  text: string;
  link: any;
  image: any;
  category: StrapiCategory;
}

const Info: React.FC<Props> = ({ title, text, image, link, category }) => (
  <div>
    {image?.data && (
      <div className={styles['image-container']}>
        <Image
          unoptimized
          src={getStrapiImageUrl(image.data.attributes.url)}
          width={image.data.attributes.width}
          height={image.data.attributes.height}
          alt={image.data.attributes.title || title}
          layout="responsive"
        />
      </div>
    )}
    <div className={styles['breadcrumbs-wrapper']}>
      <Breadcrumbs
        asLinkStyle
        staticBreadcrumbs={[
          { text: category.attributes.name, href: `/${category.attributes.slug}` },
        ]}
      />
    </div>
    {title && <h1 className={styles.title}>{title}</h1>}
    <div className={styles['dynamic-content-wrapper']}>
      {text && (
        <ReactMarkdown components={components} rehypePlugins={[rehypeRaw]}>
          {text}
        </ReactMarkdown>
      )}

      {link && (
        <Link href={link.route} passHref>
          <button type="button" className={`button green ${link.fullWidth ? 'w-full' : ''}`}>
            {link.text}
          </button>
        </Link>
      )}
    </div>
  </div>
);

export default Info;
